import {action} from '@api'
import {VipLocalStore} from '@modules'
import {IServerPDFQueryPayload, IServerRenderedPDFTemplateInstance} from '@modules/pdf'
import {DocumentLoadEvent, ScrollMode, SpecialZoomLevel} from '@react-pdf-viewer/core'
import {StoresInstance} from '@stores'
import {computed} from 'mobx'
import {ServerPDFTemplate} from './'

export class CatalogItemsGroupedPDFTemplate extends ServerPDFTemplate implements IServerRenderedPDFTemplateInstance {
  constructor(public stores: StoresInstance) {
    super(stores, 'catalogItems_grouped')
  }

  @computed
  override get text() {
    return 'Catalog (Grouped)'
  }

  @action onDocumentLoad = (e: DocumentLoadEvent) => {
    const {doc} = e,
      {
        cloudPDF: {
          defaultLayoutPluginInstance: {
            bookmarkPluginInstance,
            attachmentPluginInstance,
            thumbnailPluginInstance,
            toolbarPluginInstance: {scrollModePluginInstance, zoomPluginInstance}
          },
          component: {selectedPdf}
        }
      } = this

    // zoomPluginInstance.zoomTo(SpecialZoomLevel.PageFit)
    scrollModePluginInstance.switchScrollMode(selectedPdf?.entry?.pages === 1 ? ScrollMode.Vertical : ScrollMode.Wrapped)
    //thumbnailPluginInstance.
  }

  override get esQuery() {
    const {catalog: {groupBy: {viewStore: {mgr: {queryVariablesBody}}}}} = this
    return queryVariablesBody

  }

  override get catalogFeatures() {
    return {
      // groupBy: false,
      // viewOptions: false,
      // sortBy: false,
      // imageSources: false,
      catalogFooter: false
    }
  }
}


// WEBPACK FOOTER //
// ./src/modules/pdf/serverRenderedPDF/templates/CatalogItemsGroupedPDFTemplate.ts